import sidebar from "./sidebar-list";

let filtersCount = 0,
    outputFilters = null,
    selectFilters = null,
    mobileFilters = null,
    filterResetButtons = null,
    filterRemoveButtons = null,
    isFilterChanged = false;

function updateFilterCount(value) {
    let counterNodes = document.querySelectorAll('[data-filters-count]');

    if (counterNodes) {
        if (value) {
            counterNodes.forEach((node) => {
                node.innerText = '(' + value + ')';
            });
        } else {
            counterNodes.forEach((node) => {
                node.innerText = '';
            });
        }
    }
    filtersCount = value;
}

function updateFilterValue(properties) {
    let filterNodes = document.querySelectorAll('[data-filter-anchor=' + properties.id + ']');

    if (filterNodes) {
        filterNodes.forEach((filter) => {
            filter.querySelector('.filter__value').innerText = properties.value;
            filter.dataset.filterId = properties.valueId;
        });
    }
}

function handlePopupListToggle() {
    let mobileFilterItems = document.querySelectorAll('.navigation-filters__label');
    if (mobileFilterItems) {
        $('.navigation-filters__label').on('click', function (e) {
            if (!$(this).closest('.navigation-filters__item').hasClass('show')) {
                $(".navigation-filters__item").removeClass('show');
                $(this).closest('.navigation-filters__item').addClass('show');
            } else {
                if (!$(e.target).closest(".navigation-filters__item__inner-wrapper").length) {
                    $(this).closest('.navigation-filters__item').toggleClass('show');
                } else {

                    $(this).closest('.navigation-filters__item').addClass('show');
                }
            }
            let countFilters = $(this).closest('.has-sub').find('input:checked').length;
            let countFiltersElement = $(this).closest('.has-sub').find('.navigation-filters__counter');
            if (countFilters) {
                isFilterChanged = true;
                countFiltersElement.html(countFilters).css('opacity', 1);
            } else {
                countFiltersElement.css('opacity', 0);
            }
        });
    }
}

function init() {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    $("#slider-range").slider({
        range: true,
        min: 1,
        max: 1130,
        values: [ 1, 1130 ],
        slide: function (event, ui) {
            $(".min").val(ui.values[0]);
            $(".max").val(ui.values[1]);
            $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', ui.values[0]).attr('data-max', ui.values[1]);
        }
    });
    $('.min').on(' change', function () {
        $("#slider-range").slider('values', 0, $(this).val());
        $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', $("#slider-range").slider("values", 0)).attr('data-max', $("#slider-range").slider("values", 1));
    });

    $('.max').on(' change', function () {
        $("#slider-range").slider('values', 1, $(this).val());
        $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', $("#slider-range").slider("values", 0)).attr('data-max', $("#slider-range").slider("values", 1));
    });
    makeFilterCall(generateDataToProductsCall(urlParams));

    onSearchCategoryClick(urlParams);

    selectFilters = document.querySelectorAll('[data-role=filter]');
    mobileFilters = document.querySelectorAll('[data-role=filter-checkbox]');
    outputFilters = document.querySelectorAll('.categories__filters__output');
    filterResetButtons = document.querySelectorAll('[data-role=filter-reset]');
    filterRemoveButtons = document.querySelectorAll('.filter__remove');


    if (mobileFilters.length) {

        handlePopupListToggle();
        mobileFilters.forEach((checkbox) => {
            checkbox.addEventListener('click', (event) => {
                let filterProperties = {
                    id: checkbox.dataset.filterId,
                    name: checkbox.title,
                    value: checkbox.dataset.name,
                    valueId: checkbox.value,
                    type: 'checkbox'
                };
                handleFilterChange(filterProperties);
            });
        });
    }

    if (selectFilters.length) {
        selectFilters.forEach((select) => {
            select.addEventListener('change', () => {
                let filterProperties = {
                    id: select.dataset.filterId,
                    name: select.title,
                    value: $(select).find("option:selected")[0].label,
                    valueId: select.value,
                    type: 'select'
                };
                handleFilterChange(filterProperties);
            });
        });
    }

    if (filterRemoveButtons.length) {
        filterRemoveButtons.forEach((button) => {
            button.addEventListener('click', () => {
                removeFilterNode(button.parentNode);
            });
        });
    }

    if (filterResetButtons.length) {
        filterResetButtons.forEach((button) => {
            button.addEventListener('click', () => {
                resetFilters();
            });
        });
    }

    $(document).on('click', function (e) {
        if (!$(e.target).closest(".navigation-filters__item").length && !$(e.target).closest(".navigation-filters__item__inner-wrapper").length) {
            $(".navigation-filters__item").removeClass('show');
            if(isFilterChanged) {
                makeFilterCall(generateDataToProductsCall(urlParams));
            }
        }
    });

    $('[data-clear-upper-filters]').on('click', function () {
        let test = $(this).data('clear-upper-filters');
        if (test === 'prize-slider') {
            $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', 1).attr('data-max', 1130);
            $("#slider-range").slider("destroy");
            $("#slider-range").slider({
                range: true,
                min: 1,
                max: 1130,
                values: [ 1, 1130 ],
                slide: function (event, ui) {
                    $(".min").val(ui.values[0]);
                    $(".max").val(ui.values[1]);
                    $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', ui.values[0]).attr('data-max', ui.values[1]);
                }
            });

            $('.min').val(1);

            $('.max').val(1130);
        } else {
            $('input[name="' + test + '"').each(function (index, elem) {
                $(elem).prop('checked', false);
            });
            let countFilters = $(this).closest('.has-sub').find('input:checked').length;
            let countFiltersElement = $(this).closest('.has-sub').find('.navigation-filters__counter');
            if (countFilters) {
                countFiltersElement.html(countFilters).css('opacity', 1);
            } else {
                countFiltersElement.css('opacity', 0);
            }
        }
    });

    $('.navigation-filters__item__inner-wrapper--sort input').on('change', function () {
        urlParams.set('sort', getSortValue());
        makeFilterCall(generateDataToProductsCall(urlParams));
    });
}


function onSearchCategoryClick(urlParams) {
    $('body').on('click', '[data-search-cat-id]', function () {
        urlParams.set('currentCat', $(this).data('search-cat-id'));
        makeFilterCall(generateDataToProductsCall(urlParams));
    });
}

function generateDataToProductsCall(urlParams) {
    getPrizeRangeFilter(urlParams);
    const ajaxData = {
        action: 'get_filtered_products_list',
    };

    if (urlParams.has('currentCat')) {
        ajaxData.currentCat = urlParams.get('currentCat');
    } else {
        if ($('.archive-page').data('cat-id')) {
            urlParams.set('currentCat', $('.archive-page').data('cat-id'));
            ajaxData.currentCat = urlParams.get('currentCat');
        } else {
            urlParams.delete('currenCat');
        }
    }

    if (urlParams.has('termsIds')) {
        ajaxData.termsIds = urlParams.get('termsIds').split(',');
    }

    if (urlParams.has('s')) {
        ajaxData.s = urlParams.get('s');
    }

    if (urlParams.has('currentPage')) {
        ajaxData.currentPage = parseInt(urlParams.get('currentPage'));
    } else {
        urlParams.set('currentPage', '1');
        ajaxData.currentPage = parseInt(urlParams.get('currentPage'));
    }

    if (urlParams.has('sort')) {
        ajaxData.sort = urlParams.get('sort').toString();
    }

    if (urlParams.has('prize')) {
        ajaxData.prize = urlParams.get('prize').split(',');
    }

    markAllFilters(urlParams);

    window.history.pushState('{}', 'Title', '?' + urlParams);
    return ajaxData;
}

function markAllFilters(urlParams) {
    if (urlParams.has('termsIds')) {
        const filters = urlParams.get('termsIds').split(',');

        filters.forEach(function (item) {
            $('input[data-value="' + item + '"]').prop('checked', true);

            let countFilters = $('input[data-value="' + item + '"]').closest('.has-sub').find('input:checked').length;
            let countFiltersElement = $('input[data-value="' + item + '"]').closest('.has-sub').find('.navigation-filters__counter');
            if (countFilters) {
                countFiltersElement.html(countFilters).css('opacity', 1);
            } else {
                countFiltersElement.css('opacity', 0);
            }
        });
    }

    if (urlParams.has('sort')) {
        $('input[value="' + urlParams.get('sort') + '"]').prop('checked', true);
    }
}

function resetFilters() {
    window.dispatchEvent(new CustomEvent('range-reset', {
                bubbles: true,
                composed: true,
                detail: {sliderId: 'rangeSelector1'}
            }
        )
    );
    window.addEventListener('range-reset', function () {
        window.addEventListener('range-changed', (e) => {
            const data = e.detail;
            $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', data.minRangeValue).attr('data-max', data.maxRangeValue);
        });
    });
    $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', 1).attr('data-max', 10000);

    outputFilters.forEach((list) => {
        list.innerHTML = '';
    });

    selectFilters.forEach((select) => {
        select.getElementsByTagName('option')[0].selected = 'selected';
    });

    $('.categories__filters.d-none input[type=checkbox]').each(function (index, elem) {
        $(elem).prop('checked', false);
        $('.navigation-filters__counter').each(function (index, elem) {
            $(elem).css('opacity', 0);
        });
    });

    $('#filtersPopup input[type=checkbox]').each(function (index, elem) {
        $(elem).prop('checked', false);
    });
    mobileFilters.forEach((checkbox) => {
        (checkbox.checked) ? checkbox.checked = false : false;
    });
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    makeFilterCall(generateDataToProductsCall(urlParams));
}

function removeFilterNode(filterNode) {

    document.querySelector('select[data-filter-id=' + filterNode.dataset.filterAnchor + ']')
        .getElementsByTagName('option')[0].selected = 'selected';

    document.querySelector('[type=checkbox][data-filter-id=' + filterNode.dataset.filterAnchor + ']').checked = false;
    $('[data-filter-anchor=' + filterNode.dataset.filterAnchor + ']').each(function (index, div) {
        div.remove();
    });
}

function createFilterNode(properties) {
    let filter = document.createElement('div'),
        filterName = document.createElement('span'),
        filterValue = document.createElement('span'),
        filterRemove = document.createElement('span');

    filter.dataset.filterAnchor = properties.id;
    filter.className = 'filter';
    filterName.className = 'filter__name';
    filterName.innerText = properties.name + ': ';
    filterValue.className = 'filter__value';
    filterValue.innerText = properties.value;
    filter.dataset.filterId = properties.valueId;
    filterRemove.className = 'filter__remove';
    filterRemove.addEventListener('click', function (event) {
        removeFilterNode(event.target.parentNode);
    });

    filter.append(filterName, filterValue, filterRemove);

    let clonedFilter = $(filter).clone();

    // outputFilters[0].append(filter);
    // outputFilters[1].append(clonedFilter[0]);

    // updateFilterCount(filtersCount + 1);
}

function handleFilterChange(properties) {
    let existingFilter = document.querySelector('[data-filter-anchor=' + properties.id + ']');

    if (!existingFilter) {
        createFilterNode(properties);
    } else {
        if (existingFilter) {
            updateFilterValue(properties);
        }
    }
}

function getFilteredProducts() {
    $('[data-filter-button], [data-clear-upper-filters]').on('click', function () {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (getAllActiveFilters().length) {
            urlParams.set('termsIds', getAllActiveFilters());
        } else {
            urlParams.delete('termsIds');
        }
        urlParams.set('currentPage', '1');
        makeFilterCall(generateDataToProductsCall(urlParams));
    });

    $('body.tax-product_cat, body.search').on('click', ' a.page-numbers, span.page-numbers', function (e) {
        e.preventDefault();
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if ($(this).hasClass('dots')) {
            return;
        }
        if ($(this).hasClass('prev')) {
            let page = parseInt(urlParams.get('currentPage')) - 1;
            urlParams.set('currentPage', page.toString());
            makeFilterCall(generateDataToProductsCall(urlParams), true);
        } else if ($(this).hasClass('next')) {
            let page = parseInt(urlParams.get('currentPage')) + 1;
            urlParams.set('currentPage', page.toString());
            makeFilterCall(generateDataToProductsCall(urlParams), true);
        } else {
            urlParams.set('currentPage', $(this)[0].innerText);
            makeFilterCall(generateDataToProductsCall(urlParams), true);
        }
    });
}

function getAllActiveFilters() {
    let filtersIds = [];

    $('.navigation-filters__item__inner-wrapper--filters').each(function (index, element) {
        let subfilters = [];
        $(element).find('input[type=checkbox]:checked').each(function (subIndex, subItem) {
            if (subItem) {
                subfilters = [...subfilters, parseInt(subItem.value)];
            }
        });
        if (subfilters.length) {
            filtersIds = [...filtersIds, subfilters];
        }
    });
    return filtersIds;
}

function getSortValue() {
    let sort = 'default';
    sort = $('.categories__filters input[type=radio]:checked').val();
    return sort;
}

window.addEventListener('range-changed', (e) => {
    const data = e.detail;
    $('.navigation-filters__item__inner-wrapper--prize').attr('data-min', data.minRangeValue).attr('data-max', data.maxRangeValue);
});

function getPrizeRangeFilter(urlParams) {
    const min = parseInt($('.navigation-filters__item__inner-wrapper--prize').attr('data-min')),
        max = parseInt($('.navigation-filters__item__inner-wrapper--prize').attr('data-max'));

    if(min && max) {
        urlParams.set('prize', [min, max].join(','));
    } else {
        urlParams.delete('prize');
    }
}

function makeFilterCall(ajaxData, doScroll = false) {
    $('main').append('<div class="loader-wrapper loader-wrapper--category" style="z-index: 10;"><span class="loader"></span></div>');
    $('.navigation-filters__item.has-sub').removeClass('show');
    ajaxData.termsIds = getAllActiveFilters();
    $.post(settings.ajax_url, ajaxData)
        .done((response) => {
            response = JSON.parse(response);
            if (response.newProducts) {
                $('.products, .woocommerce.columns-4').replaceWith(response.newProducts);
                $('main .loader-wrapper--category').remove();

                if (doScroll) {
                    let offset = $('.categories__filters')[0].offsetTop + $('.categories__filters')[0].clientHeight;
                    $("html, body").animate({scrollTop: offset + 150}, 500);
                }
                isFilterChanged = false;
            }
            if (response.newCategories) {
                $('.navigation-categories').replaceWith(response.newCategories);
                sidebar.init();
            }
            if (response.pagination) {
                $('.pagination__wrapper, .pagination').replaceWith(response.pagination);
            }
        });
}

export default {init, getFilteredProducts};



// WEBPACK FOOTER //
// ./src/scripts/filters.js